export default __webpack_public_path__ + "static/media/Arca.8226de27.png";